export default {
  "actions": {
    "skip_intro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["跳過中場休息/介紹動畫"])},
    "skip_sponsors": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["跳過贊助商"])},
    "enable_sponsorblock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["啟用 SponsorBlock"])},
    "country_selection": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["國家/地區選擇"])},
    "channel_name_desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通道名稱 (Z-A)"])},
    "channel_name_asc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通道名稱 (A-Z)"])},
    "unsubscribe": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消訂閱"])},
    "subscribe": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂閱"])},
    "sort_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["排序方式:"])},
    "view_subscriptions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查看訂閱"])},
    "language_selection": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["語言選擇"])}
  },
  "titles": {
    "history": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["歷史記錄"])},
    "preferences": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["偏好設定"])},
    "feed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["摘要"])},
    "trending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["趨勢"])},
    "register": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["註冊"])},
    "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登錄"])}
  }
}